import { render, staticRenderFns } from "./EditAccountPopup.vue?vue&type=template&id=5c064eb6"
import script from "./EditAccountPopup.vue?vue&type=script&lang=js"
export * from "./EditAccountPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports